import { useCallback as s } from "../../../external/preact/hooks/dist/hooks.module.js";
import { InteractionKeyCode as c } from "../../types.js";
import a from "../../../hooks/useBooleanState.js";
const m = () => {
  const [n, o] = a(), t = s(() => o(!0), [o]), e = s(() => o(!1), [o]), i = s(
    (r) => {
      switch (r.code) {
        case c.ESCAPE:
          e();
          break;
      }
    },
    [e]
  );
  return {
    listeners: {
      onfocusoutCapture: e,
      onMouseLeave: e,
      onKeyDown: i,
      onFocus: t,
      onMouseEnter: t
    },
    isVisible: n
  };
};
export {
  m as useTooltipListeners
};
